import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import * as styles from './Card.css';
import { dt } from '../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);

/* istanbul ignore next */
class Card extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */

        automationId: PropTypes.string,

        /**
         * Custom class for card
         * @type {String}
         */

        cardClass: PropTypes.string,
        callbackRef: PropTypes.func,
    };

    static defaultProps = {
        children: [],
        automationId: '',
        cardClass: '',
        callbackRef: null,
    };

    setCardRef = (element) => {
        this.props.callbackRef && this.props.callbackRef(element);
    };

    render() {
        const { automationId, cardClass } = this.props;
        const cardWrapperStyles = dt([
            'inline-block',
            'relative',
            'border-[0.0625rem]',
            'border-solid',
            'border-gray-15',
            'bg-white',
            'shadow-elevation1',
            'rounded-[0.1875rem]',
            'w-full',
            'h-full',
        ]);
        return (
            <div
                ref={this.setCardRef}
                className={`${cardWrapperStyles} ${cx('cardWrapper', cardClass)}`}
                data-automation-id={automationId}
            >
                {this.props.children}
            </div>
        );
    }
}

export default Card;
